import httpname from "./axios/http-apiGenOp";

class GenerateOp {
    generate_billing_no_for_zau(data) {
        return httpname.post("/op-generate-zau", data);
    }
}

export default new GenerateOp();